import { PagedResult, Result, CommunityEvent, RecurringCommunityEvent } from "../models/index";

import { DateFields as CommunityEventDateFields } from "../models/CommunityEvent";
import { RecurringDateFields as RecurringDateFields } from "../models/CommunityEvent";

import { ServiceBase, convertStringsToDates } from "./ServiceBase";

export class SearchCalendarIn {
    startDate: string;
    endDate: string;

    constructor() {
        this.startDate = '';
        this.endDate = '';
    }

    public static fromInput(input: Partial<SearchCalendarIn>) {
        var result = new SearchCalendarIn();
        result = { ...result, ...input };
        return result;
    }
}

export class OakvilleCentreSearchCalendarIn {
    startDate: string;
    endDate: string;
    tagId: string;

    constructor() {
        this.startDate = '';
        this.endDate = '';
    }

    public static fromInput(input: Partial<OakvilleCentreSearchCalendarIn>) {
        var result = new OakvilleCentreSearchCalendarIn();
        result = { ...result, ...input };
        return result;
    }
}

export class SearchListIn {
    keywords: string;
    categories: string;
    path?: string;

    constructor() {
        this.keywords = '';
        this.categories = '';
    }

    public static fromInput(input: Partial<SearchListIn>) {
        var result = new SearchListIn();
        result = { ...result, ...input };
        return result;
    }
}

const preProcessDates = (input: CalendarSearchResult) => {

    input.items = input.items.map(item => convertStringsToDates(item, CommunityEventDateFields));
    input.recurringEvents = input.recurringEvents.map(item => convertStringsToDates(item, RecurringDateFields));

    return input;
}

export class CommunityEventsService extends ServiceBase {

    public static async searchForCalendar(filters: SearchCalendarIn): Promise<Result<CalendarSearchResult>> {

        var result = await this.requestJson<CalendarSearchResult>({
            url: `/api/events/eventsforcalendar/`.toLocaleLowerCase(),
            method: "POST",
            data: filters
        }, preProcessDates);

        return result;
    }
}

export class OakvilleCentreCommunityEventsService extends ServiceBase {

    public static async searchForCalendar(filters: OakvilleCentreSearchCalendarIn): Promise<Result<CalendarSearchResult>> {

        var result = await this.requestJson<CalendarSearchResult>({
            url: `/api/OakvilleCentreEvents/eventsforcalendar/`.toLocaleLowerCase(),
            method: "POST",
            data: filters
        }, preProcessDates);

        return result;
    }
}

export class CalendarSearchResult extends PagedResult<CommunityEvent> {
    recurringEvents: RecurringCommunityEvent[]
}
